import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { CurrencyContext } from 'contexts'
import React from 'react'
import { FormattedNumber } from 'react-intl'

const stats = [
  {
    title: 'Winning sessions',
    format: ({ win }) => (
      <FormattedNumber value={win} minimumFractionDigits={0} />
    ),
  },
  {
    title: 'Losing sessions',
    format: ({ loss }) => (
      <FormattedNumber value={loss} minimumFractionDigits={0} />
    ),
  },
  {
    title: 'Session win percentage',
    format: ({ win_perc }) => (
      <>
        <FormattedNumber value={win_perc} minimumFractionDigits={2} />
        <sup>%</sup>
      </>
    ),
  },
  {
    title: 'Biggest session win',
    format: ({ max_win }, { currency }) => (
      <>
        <sup>
          <FontAwesomeIcon icon={currency.icon} />
        </sup>
        <FormattedNumber value={max_win} minimumFractionDigits={2} />
      </>
    ),
  },
  {
    title: 'Biggest session loss',
    format: ({ max_loss }, { currency }) => (
      <span className="text-danger">
        <sup>
          <FontAwesomeIcon icon={['far', 'minus']} />
          <FontAwesomeIcon icon={currency.icon} />
        </sup>
        <FormattedNumber value={Math.abs(max_loss)} minimumFractionDigits={2} />
      </span>
    ),
  },
  {
    title: 'Average session duration',
    format: ({ avg_length }) => (
      <>
        <FormattedNumber value={avg_length} minimumFractionDigits={2} />
        <sup>hrs</sup>
      </>
    ),
  },
  {
    title: 'Average session win',
    format: ({ avg_win }, { currency }) => (
      <>
        <sup>
          <FontAwesomeIcon icon={currency.icon} />
        </sup>
        <FormattedNumber value={avg_win} minimumFractionDigits={0} />
      </>
    ),
  },
  {
    title: 'Average session loss',
    format: ({ avg_loss }, { currency }) => (
      <span className="text-danger">
        <sup>
          <FontAwesomeIcon icon={['far', 'minus']} />
          <FontAwesomeIcon icon={currency.icon} />
        </sup>
        <FormattedNumber value={Math.abs(avg_loss)} minimumFractionDigits={0} />
      </span>
    ),
  },
  {
    title: 'All time high',
    format: ({ all_time }, { currency }) => (
      <>
        <sup>
          <FontAwesomeIcon icon={['far', 'plus']} />
          <FontAwesomeIcon icon={currency.icon} />
        </sup>
        <FormattedNumber value={all_time} minimumFractionDigits={0} />
      </>
    ),
  },
]

export default function StatsTable({ bankroll }) {
  const currency = React.useContext(CurrencyContext)
  return (
    <table className="table table-sm">
      <tbody>
        {stats.map(({ title, format }) => (
          <tr key={title}>
            <td>{title}</td>
            <td>{format(bankroll.stats, { currency })}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
